import { formatDate } from "@/lib/utils";
import {
  Badge,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
  Text,
} from "@a7y/tailwind-catalyst";
import { CommissionStateBadge, formatCents, Section } from "../shared";
import type { AffiliateCommission } from "../types";

export function CommissionsTab({ commissions }: { commissions: AffiliateCommission[] }) {
  return (
    <Section title={`Commissions (${commissions.length})`}>
      <Table dense striped>
        <TableHead>
          <TableRow>
            <TableHeader>State</TableHeader>
            <TableHeader>Amount</TableHeader>
            <TableHeader>Invoice</TableHeader>
            <TableHeader>Due</TableHeader>
            <TableHeader>Flags</TableHeader>
            <TableHeader>Created</TableHeader>
          </TableRow>
        </TableHead>
        <TableBody>
          {commissions.length === 0 ? (
            <TableRow>
              <TableCell colSpan={6} className="py-6 text-center">
                <Text className="text-sm text-zinc-500">No commissions yet</Text>
              </TableCell>
            </TableRow>
          ) : (
            commissions.map((c) => (
              <TableRow key={c.id}>
                <TableCell>
                  <CommissionStateBadge state={c.state} />
                </TableCell>
                <TableCell className="font-medium">
                  {formatCents(c.amountCents, c.currency)}
                </TableCell>
                <TableCell className="font-mono text-xs">{c.stripeInvoiceId}</TableCell>
                <TableCell className="text-sm text-zinc-500">{formatDate(c.dueAt)}</TableCell>
                <TableCell className="space-x-1">
                  {c.firstCommissionHold && <Badge color="amber">First-hold</Badge>}
                  {c.disputeHold && <Badge color="red">Dispute</Badge>}
                  {c.clawbackFlaggedForAdmin && <Badge color="red">Clawback</Badge>}
                </TableCell>
                <TableCell className="text-sm text-zinc-500">{formatDate(c.createdAt)}</TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </Section>
  );
}
